/**
 * @generated SignedSource<<c4bf7b722981f9a5f654701df2613a5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildPrimaryPhotoNew_guild$data = {
  readonly name: string;
  readonly primaryPhoto: {
    readonly colorPalette: any | null | undefined;
    readonly transformUrl: string;
  } | null | undefined;
  readonly rowId: string;
  readonly " $fragmentType": "GuildPrimaryPhotoNew_guild";
};
export type GuildPrimaryPhotoNew_guild$key = {
  readonly " $data"?: GuildPrimaryPhotoNew_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildPrimaryPhotoNew_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "dpr",
                  "variableName": "dpr"
                },
                {
                  "kind": "Literal",
                  "name": "fit",
                  "value": "cover"
                },
                {
                  "kind": "Variable",
                  "name": "h",
                  "variableName": "imageSize"
                },
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "imageSize"
                }
              ],
              "kind": "ObjectValue",
              "name": "transform"
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "colorPalette",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "fb65e4503731fa03690e5a6c665f17ff";

export default node;
